import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React, { useState } from 'react';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

const useStyles = makeStyles((theme) => ({
  cardHeaderRoot: {
    alignItems: 'center',
  },
  cardHeaderAction: {
    marginTop: 0,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
  },
  dataTitle: {
    fontSize: 16,
    fontWeight: 500,
  },
  expand: {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

interface IProps {
  contract: ISubscriptions;
}

const ContractCard = ({ contract }: IProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded((prevState) => !prevState);
  };

  return (
    <Grid item xs={12} md={4}>
      <Card>
        <CardHeader
          avatar={<Avatar src={contract?.product?.image} />}
          title={`Contrato ${contract?.id}`}
          subheader={contract?.product?.title}
          classes={{ title: classes.title, root: classes.cardHeaderRoot, action: classes.cardHeaderAction }}
          action={
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
            >
              <ExpandMoreIcon />
            </IconButton>
          }
        />
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <CardContent>
            <Typography variant='h6'>Cliente</Typography>
            <Grid container spacing={2}>
              <>
                <Grid item md={6}>
                  <Typography className={classes.dataTitle}>Nome:</Typography>
                  <Typography variant='body2'>{contract?.customer?.name}</Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography className={classes.dataTitle}>Tipo de frequência:</Typography>
                  <Typography variant='body2'>{contract?.frequency_details?.frequency_type || '-'}</Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography className={classes.dataTitle}>Frequência:</Typography>
                  <Typography variant='body2'>{contract?.frequency_details?.frequency || '-'}</Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography className={classes.dataTitle}>Limite de cobrança:</Typography>
                  <Typography variant='body2'>{contract?.frequency_details?.number_of_charges || '-'}</Typography>
                </Grid>
              </>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
    </Grid>
  );
};

export default ContractCard;
